import { Input, InputRef, Space } from 'antd';
import { Button } from '@quinyx/ui';
import { FilterDropdownProps } from 'antd/lib/table/interface';
import React, { FC, Key, useEffect, useRef } from 'react';

import { useTranslate } from '../../../hooks/translate';

interface IFilterDropdownProps extends FilterDropdownProps {
  setSearchText: (text: Key) => void;
  setSearchedColumn: (column: string) => void;
  dataIndex: string;
  close: () => void;
}

const FilterDropdown: FC<IFilterDropdownProps> = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  dataIndex,
  setSearchText,
  setSearchedColumn,
  close,
  visible,
}) => {
  const { t } = useTranslate();
  const searchInput = useRef<InputRef>(null);

  useEffect(() => {
    if (visible) {
      setTimeout(() => {
        searchInput.current?.input?.focus();
      }, 100);
    }
  }, [visible]);

  const handleSearch = (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.nativeEvent instanceof KeyboardEvent) {
      event.stopPropagation();
    }
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = () => {
    setSearchText('');
    setSearchedColumn('');
    if (clearFilters) clearFilters();
    confirm();
  };

  const handleFilter = () => {
    confirm({ closeDropdown: false });
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  return (
    <div style={{ padding: 8 }}>
      <Input
        ref={searchInput}
        placeholder={t('common.searchColumn', { column: dataIndex })}
        value={selectedKeys[0] as string}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={handleSearch}
        style={{ marginBottom: 8, display: 'block' }}
      />
      <Space>
        <Button
          data-test-id="search-button"
          onClick={handleSearch}
          leftIcon="search"
          text={t('common.search')}
        />
        <Button
          data-test-id="reset-button"
          onClick={handleReset}
          text={t('common.reset')}
          variant="text"
        />
        <Button
          data-test-id="filter-button"
          onClick={handleFilter}
          text={t('common.filter')}
          variant="text"
        />
        <Button
          data-test-id="close-button"
          onClick={close}
          aria-label={t('common.close')}
          icon="close"
          variant="text"
        />
      </Space>
    </div>
  );
};

export default FilterDropdown;
